import React from 'react';
import { Container, Typography, Button, Box, Paper } from '@mui/material';
import { useNotifications } from '../context/NotificationContext';
import NotificationContainer from '../components/NotificationContainer';

const Test = () => {
  const { showSuccess, showWarning, showInfo, showError } = useNotifications();

  const handleShowSuccess = () => {
    showSuccess('Это успешное уведомление!');
  };

  const handleShowWarning = () => {
    showWarning('Это предупреждающее уведомление!');
  };

  const handleShowInfo = () => {
    showInfo('Это информационное уведомление!');
  };

  const handleShowError = () => {
    showError('Это уведомление об ошибке!');
  };

  return (
    <div style={{ backgroundColor: '#f5f5f5', minHeight: '100vh', padding: '20px' }}>
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Тестирование уведомлений
          </Typography>
          
          <Typography variant="body1" paragraph align="center" sx={{ mb: 4 }}>
            Нажмите на кнопки ниже, чтобы протестировать различные типы уведомлений
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
            <Button
              variant="contained"
              color="success"
              size="large"
              onClick={handleShowSuccess}
              sx={{ minWidth: 200 }}
            >
              Показать Success
            </Button>
            
            <Button
              variant="contained"
              color="warning"
              size="large"
              onClick={handleShowWarning}
              sx={{ minWidth: 200 }}
            >
              Показать Warning
            </Button>
            
            <Button
              variant="contained"
              color="info"
              size="large"
              onClick={handleShowInfo}
              sx={{ minWidth: 200 }}
            >
              Показать Info
            </Button>
            
            <Button
              variant="contained"
              color="error"
              size="large"
              onClick={handleShowError}
              sx={{ minWidth: 200 }}
            >
              Показать Error
            </Button>
          </Box>

          <Typography variant="body2" sx={{ mt: 4, textAlign: 'center', color: 'text.secondary' }}>
            Уведомления будут появляться в правом нижнем углу экрана
          </Typography>
        </Paper>
      </Container>
      
      <NotificationContainer />
    </div>
  );
};

export default Test;